<template>
  <div>
    <div class="auth">
      <div class="grayHead">
        <span>
          メールアドレスのメールに送信された確認コードを入力してください。
        </span>
      </div>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        name="userLoginForm"
        class="form"
        @submit.prevent="validateBeforeSubmit()"
      >
        <InputText
          v-model="form.authentication_code"
          :vid="'authentication_code'"
          :label="'確認コード'"
          :maxlength="4"
          rules="required|numeric|digits:4"
          class="form__group"
        />

        <!-- Submit Button -->
        <div class="form__group mt72">
          <Btn
            :label="'送信'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import error from '@/mixin/error.mixin'
import store from '@/store'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'AccountCreateStep02Code',

  mixins: [error],

  components: {
    InputText,
    Btn
  },

  beforeRouteEnter (from, to, next) {
    if (!store.getters['accountCreate/code_request_id']) {
      return next({name: 'AccountCreateStep01Mail'})
    }

    const id = from.params['id']
    store.commit('loadingAction', false)

    next(vm => {
      vm.id = id
    })
  },

  data () {
    return {
      id: null,
      form: {
        authentication_code: ''
      }
    }
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.submit()
      }
    },

    submit () {
      this.$store.commit('loadingAction', true)
      this.$store.dispatch('accountCreate/checkRegisterCode', {
        id: this.id,
        authentication_code: this.form.authentication_code
      }).then((_res) => {
        this.$router.push({
          name: 'AccountCreateStep03Form'
        }).catch(() => {})
      }).catch((err) => {
        this.$store.commit('loadingAction', false)
        this.addValidateErrors(this.$refs.observer, err)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/form.pcss';
</style>



// WEBPACK FOOTER //
// src/pages/account-create/Step02Code.vue